/** ISO 3166-1 alpha-2 codes for flag emojis */
const COUNTRY_CODES = {
  Albania: "AL",
  Australia: "AU",
  Austria: "AT",
  Azerbaijan: "AZ",
  Bahrain: "BH",
  Bangladesh: "BD",
  Barbados: "BB",
  Belgium: "BE",
  Brazil: "BR",
  Bulgaria: "BG",
  Cambodia: "KH",
  Canada: "CA",
  China: "CN",
  Colombia: "CO",
  "Costa Rica": "CR",
  Croatia: "HR",
  Cyprus: "CY",
  "Czech Republic": "CZ",
  Denmark: "DK",
  "Dominican Republic": "DO",
  Egypt: "EG",
  Fiji: "FJ",
  France: "FR",
  Germany: "DE",
  Greece: "GR",
  "Hong Kong": "HK",
  Hungary: "HU",
  Iceland: "IS",
  India: "IN",
  Indonesia: "ID",
  Ireland: "IE",
  Italy: "IT",
  Jamaica: "JM",
  Japan: "JP",
  Jordan: "JO",
  Kenya: "KE",
  Kuwait: "KW",
  Malaysia: "MY",
  Maldives: "MV",
  Malta: "MT",
  Mauritius: "MU",
  Mexico: "MX",
  Montenegro: "ME",
  Morocco: "MA",
  Nepal: "NP",
  Netherlands: "NL",
  "New Zealand": "NZ",
  Norway: "NO",
  Oman: "OM",
  Pakistan: "PK",
  Philippines: "PH",
  Poland: "PL",
  Portugal: "PT",
  Qatar: "QA",
  Romania: "RO",
  "Saudi Arabia": "SA",
  Singapore: "SG",
  "South Africa": "ZA",
  "South Korea": "KR",
  Spain: "ES",
  "Sri Lanka": "LK",
  Switzerland: "CH",
  Tanzania: "TZ",
  Thailand: "TH",
  Tunisia: "TN",
  Turkey: "TR",
  "United Arab Emirates": "AE",
  "United Kingdom": "GB",
  "United States": "US",
  Uzbekistan: "UZ",
  Vietnam: "VN",
};

export function countryToFlag(name) {
  const code = COUNTRY_CODES[name];
  if (!code || code.length !== 2) return "🌍";
  return code
    .toUpperCase()
    .split("")
    .map((char) => String.fromCodePoint(127397 + char.charCodeAt(0)))
    .join("");
}

/** Quick picks shown as chips above the full list */
export const FEATURED_DESTINATIONS = [
  "Turkey",
  "United Arab Emirates",
  "Saudi Arabia",
  "Maldives",
  "Thailand",
  "Egypt",
  "Greece",
  "Spain",
  "United Kingdom",
  "United States",
];

export const DESTINATION_REGIONS = [
  {
    id: "middle-east",
    label: "Middle East & Gulf",
    destinations: [
      "Bahrain",
      "Jordan",
      "Kuwait",
      "Oman",
      "Qatar",
      "Saudi Arabia",
      "Turkey",
      "United Arab Emirates",
    ],
  },
  {
    id: "europe",
    label: "Europe",
    destinations: [
      "Albania",
      "Austria",
      "Belgium",
      "Bulgaria",
      "Croatia",
      "Cyprus",
      "Czech Republic",
      "Denmark",
      "France",
      "Germany",
      "Greece",
      "Hungary",
      "Iceland",
      "Ireland",
      "Italy",
      "Malta",
      "Montenegro",
      "Netherlands",
      "Norway",
      "Poland",
      "Portugal",
      "Romania",
      "Spain",
      "Switzerland",
      "United Kingdom",
    ],
  },
  {
    id: "asia",
    label: "Asia & Pacific",
    destinations: [
      "Azerbaijan",
      "Bangladesh",
      "Cambodia",
      "China",
      "Hong Kong",
      "India",
      "Indonesia",
      "Japan",
      "Malaysia",
      "Maldives",
      "Nepal",
      "Pakistan",
      "Philippines",
      "Singapore",
      "South Korea",
      "Sri Lanka",
      "Thailand",
      "Uzbekistan",
      "Vietnam",
    ],
  },
  {
    id: "africa",
    label: "Africa",
    destinations: ["Egypt", "Kenya", "Mauritius", "Morocco", "South Africa", "Tanzania", "Tunisia"],
  },
  {
    id: "americas",
    label: "Americas & Caribbean",
    destinations: [
      "Barbados",
      "Brazil",
      "Canada",
      "Colombia",
      "Costa Rica",
      "Dominican Republic",
      "Jamaica",
      "Mexico",
      "United States",
    ],
  },
  {
    id: "oceania",
    label: "Oceania",
    destinations: ["Australia", "Fiji", "New Zealand"],
  },
];

/** Flat list derived from regions (alphabetical) */
export const POPULAR_DESTINATIONS = DESTINATION_REGIONS.flatMap((r) => r.destinations).sort(
  (a, b) => a.localeCompare(b)
);

// Backwards-compatible export used by Packages page
export const WORLD_COUNTRIES = POPULAR_DESTINATIONS;
